export default {
  text: 'Korzystając z tej strony, zgadzasz się z naszą',
  cookie_policy: 'Polityką plików cookie.',
  buttons: {
    accept: 'Akceptuj',
    reject: 'Odrzuć',
  },
};
